var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-tooltip",
      class: [
        ((_obj = {}),
        (_obj["rb-tooltip--" + _vm.color + " "] = _vm.color),
        (_obj["rb-tooltip--padding-top"] = !this.$slots.title),
        _obj),
        [_vm.fixed ? "rb-tooltip__store" : "rb-tooltip__default"],
      ],
    },
    [
      _c(
        "button",
        {
          ref: "closeButton",
          staticClass: "common__icon close-icon",
          class: [_vm.isLightTheme],
          attrs: { "data-analytics_available_call": "0", tabindex: "0" },
          on: {
            click: _vm.onTooltipClose,
            keypress: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.onTooltipClose($event)
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.onTooltipClose($event)
            },
          },
        },
        [_vm._v("\n    close\n  ")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "rb-tooltip__pointer",
        class:
          ((_obj$1 = {}),
          (_obj$1["rb-tooltip__pointer--" + _vm.pointer] = _vm.pointer),
          _obj$1),
      }),
      _vm._v(" "),
      this.$slots.title ? _c("h5", [_vm._t("title")], 2) : _vm._e(),
      _vm._v(" "),
      this.$slots.content ? _vm._t("content") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }